import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine77B = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30 20C35.5228 20 40 15.5228 40 10C40 4.47715 35.5228 0 30 0C24.4772 0 20 4.47715 20 10C20 15.5228 24.4772 20 30 20Z",
			fill: "#82DC73"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.4494 9.14868C35.4494 8.89238 35.2707 8.7076 34.9844 8.7076C34.6981 8.7076 34.5136 8.8926 34.5136 9.14868C34.5136 9.40521 34.6983 9.58977 34.9844 9.58977C35.2705 9.58977 35.4494 9.40521 35.4494 9.14868ZM29.8527 5.05869V6.71129H29.8525C27.4668 10.8602 26.2738 13.6915 26.2738 15.2054H23.9599C23.9599 14.573 24.0557 13.9693 24.2475 13.3946C24.4103 12.9154 24.7314 12.2352 25.2103 11.3535L27.6823 6.75434H22.7527V5.05869H29.8527ZM37.449 9.9239C37.8486 9.9239 38.1405 10.0489 38.3075 10.1324L38.0509 10.7465C37.8662 10.6272 37.6101 10.5556 37.4072 10.5556C37.127 10.5556 36.9662 10.6687 36.9662 10.8596C36.9662 11.0263 37.0972 11.1039 37.2999 11.1754L37.6875 11.3185C38.1168 11.4793 38.3968 11.7417 38.3968 12.2246C38.3968 12.8446 37.8959 13.2856 37.0618 13.2856C36.6622 13.2856 36.3046 13.1485 36.1257 13.0413L36.382 12.4154C36.5849 12.5587 36.877 12.6539 37.1273 12.6539C37.3479 12.6539 37.6162 12.5824 37.6162 12.3322C37.6162 12.1117 37.3779 12.0461 37.2109 11.9804L36.8351 11.8374C36.382 11.6646 36.1973 11.3726 36.1973 10.9969C36.1973 10.3948 36.7038 9.9239 37.449 9.9239ZM31.7664 8.76716V10.4302C31.9809 10.1202 32.2255 9.90564 32.6309 9.90564C33.4653 9.90564 33.8112 10.7761 33.8112 11.545C33.8112 12.2604 33.4357 13.2561 32.4159 13.2559C32.1777 13.2559 31.8975 13.1606 31.7366 13.0115V13.1785H30.9257V8.76716H31.7664ZM35.402 9.99542V13.1787H34.5612V9.99542H35.402ZM32.3149 10.6269C32.1481 10.6269 32.0168 10.6985 31.9275 10.7878C31.7844 10.925 31.7666 11.0143 31.7666 11.1993V12.2426C31.7666 12.463 31.8977 12.6598 32.279 12.6598C32.8157 12.6598 32.9349 12.0993 32.9349 11.6643C32.9349 11.2352 32.8455 10.6272 32.3149 10.6269Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 28C31 36.2843 24.2843 43 16 43C7.71573 43 1 36.2843 1 28C1 19.7157 7.71573 13 16 13C24.2843 13 31 19.7157 31 28Z",
			fill: "#FF82B4",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5493 22.2508V19.3729H10.1862V22.3259H18.7702L14.4655 30.3346C12.9138 33.2125 12.2881 34.7144 12.2881 37.0417H16.3173C16.3177 34.264 18.6704 28.983 22.5493 22.2508Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine77B);
export { ForwardRef as ReactComponent };
